import videojs from 'video.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;
const dom = videojs.dom || videojs;

const liveButton = function() {
  const LIVE_SHIFT = 20;
  const Button = videojs.getComponent('Button');
  class LiveDisplay extends Button {
    constructor(player, options) {
      const pluginOptions = options.playerOptions.plugins && options.playerOptions.plugins.liveButton;
      super(player, pluginOptions);
      ({
        live_shift: this.live_shift = LIVE_SHIFT,
        live_bound: this.live_bound
      } = pluginOptions || {});
      if (!this.live_bound) {
        this.live_bound = this.live_shift * 2;
      }
      this.live_shift = this.live_shift;

      this.updateShowing();
      this.on(player, 'durationchange', this.updateShowing);
      this.on(player, 'timeupdate', this.updateShowing);
    }

    createEl() {
      const el = dom.createEl('button', {
        className: 'vjs-live-control vjs-control vjs-button'
      });

      this.contentEl_ = dom.createEl('div', {
        className: 'vjs-live-display',
        innerHTML: `<span class="vjs-control-text vjs-icon-placeholder">${this.localize('Stream Type')}</span>${this.localize('LIVE')}`
      }, {
        'aria-live': 'off'
      });

      el.appendChild(this.contentEl_);
      return el;
    }

    get liveStatus() {
      const player = this.player();
      if (!player.hls_) return false;
      const hls_current_level = player.hls_.currentLevel === -1 ? 0 : player.hls_.currentLevel;
      const hls_level = player.hls_.levels && player.hls_.levels[hls_current_level];
      if (!hls_level) return false;
      return hls_level && hls_level.details && hls_level.details.live;
    }

    get liveLag() {
      const player = this.player();
      if (!player.hls_) return 0;
      const fragPlaying = player.hls_.streamController.fragPlaying;
      if (!fragPlaying) {
        return 0;
      }
      const lag = (Date.now() - fragPlaying.programDateTime) / 1000;
      return lag;
    }

    updateShowing() {
      if (this.liveStatus) {
        this.show();
        this.player().addClass('vjs-live-mode');
        if (this.liveLag > this.live_bound) {
          this.addClass('clickable');
        } else if (this.liveLag <= this.live_shift + 2) {
          this.removeClass('clickable');
        }
      } else {
        this.player().removeClass('vjs-live-mode');
        this.hide();
      }
    }

    checkBehindLive() {
      return this.hasClass('clickable');
    }

    seekToCurrentTime() {
      const player = this.player();
      if (!this.liveStatus) return;
      const seek = player.currentTime() + this.liveLag - this.live_shift;
      console.log('seek to', seek);
      player.currentTime(seek);
    }

    handleClick() {
      this.seekToCurrentTime();
      this.player().trigger('LiveDisplay/seekToCurrentTime');
    }
  }
  videojs.registerComponent('LiveDisplay', LiveDisplay);
};

registerPlugin('liveButton', liveButton);

export default liveButton;
